export enum SearchType {
	data = 'data',
    content = 'content'
}